export default __webpack_public_path__ + "static/media/carbon-footprint.6b090cd1.mp4";